<template>
	<div class="mainContainer">
		<!-- 大标题 -->
		<!-- <el-row class="mainTitle">
			<el-col :span="24">标题</el-col>
		</el-row> -->
		<!-- 分段 -->
		<div  v-for="(item, index) in formData" :key="index">
			<el-row class="title" v-if="item.type == 'segment'"><el-col :span="24">{{ item.label }}</el-col></el-row>
			<!-- 文本 -->
			<el-row class="textClass" v-if="item.type == 'text'"><el-col :span="24">{{ item.label }}</el-col></el-row>
			<!-- 文本输入框 -->
			<el-row v-if="item.type == 'inputtext'">
				<el-col :span="3">{{ item.label }}</el-col>
				<el-col :span="19"><el-input :name="item.formId" :maxlength="item.maxLength" :minlength="item.minLength" v-model="item.value" :placeholder="item.hint"></el-input></el-col>
			</el-row>
			<!-- 密码输入框 -->
			<el-row v-if="item.type == 'inputpassword'">
				<el-col :span="3">{{ item.label }}</el-col>
				<el-col :span="19"><el-input :name="item.formId" v-model="item.value" :maxlength="item.maxLength" :minlength="item.minLength" :placeholder="item.hint"></el-input></el-col>
			</el-row>
			<!-- 数值输入框 -->
			<el-row v-if="item.type == 'inputnumber'">
				<el-col :span="3">{{ item.label }}</el-col>
				<el-col :span="19"><el-input :name="item.formId" v-model="item.value" :placeholder="item.hint" :maxlength="item.maxLength" :minlength="item.minLength"></el-input></el-col>
			</el-row>
			<!-- 日期 -->
			<el-row v-if="item.type == 'inputdate'">
				<el-col :span="3">{{ item.label }}</el-col>
				<el-col :span="19"><el-input :name="item.formId" :value="item.value" :placeholder="item.hint" ></el-input></el-col>
			</el-row>
			<!-- 多行文本输入框 -->
			<el-row v-if="item.type == 'textarea'">
				<el-col :span="3">{{ item.label }}</el-col>
				<el-col :span="19"><el-input class="textarea" type="textarea" :rows="2" v-model="item.value" :placeholder="item.hint"></el-input></el-col>
			</el-row>
			
			<!-- 下拉 -->
			<el-row v-if="item.type == 'dropdown'">
				<el-col :span="3">{{ item.label }}</el-col>
				<el-col :span="19">
					<el-select class="formSelect" v-model="item.dropIndex" placeholder="请选择">
						<el-option v-for="(item1,index) in item.dropOptions" :key="index" :label="item1" :value="index"></el-option>
					</el-select>
				</el-col>
			</el-row>
			
			<!-- 单选 -->
			<el-row v-if="item.type == 'radiobuttons'">
				<el-col :span="3">{{ item.label }}</el-col>
				<el-col :span="19">
					<el-radio-group class="radioButton" v-model="item.radioIndex" :name="item.formId" v-for="(item1, index) in item.radioItems" :key="index">
						<el-radio class="radioClass" :label="item1.value">{{item1.label}}</el-radio>
					</el-radio-group>
				</el-col>
			</el-row>
			
			<!-- 多选 -->
			<el-row v-if="item.type == 'checkboxes'">
				<el-col :span="3">{{ item.label }}</el-col>
				<el-col :span="19">
					<el-checkbox v-for="(item1, index) in item.checkItems" :key="index" v-model="item1.checked">{{ item1.label }}</el-checkbox>
					<!-- <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
						<el-checkbox v-for="(item1, index) in item.checkItems" :key="index" :label="item1.label">{{ item1.label }}</el-checkbox>
					</el-checkbox-group> -->
				</el-col>
			</el-row>
		</div>
		
	</div>
</template>

<script>
export default {
	props:["formData"],
	data() {
		return {
			options: [
				{
					value: '选项1',
					label: '黄金糕'
				}
			],
			value: '',
			radio: 3,
			checkedCities: ['上海', '北京'],
			cities: ['上海', '北京', '广州', '深圳']
		};
	},
	
	methods: {
		handleCheckedCitiesChange(value) {
			window.console.log(value);
		}
	}
};
</script>

<style scoped="scoped">
.mainContainer {
	width: 95%;
	/* border: 1px solid red; */
	margin: 0 auto;
}
.mainContainer .title {
	padding: 10px 14px;
	background-color: #f5f5f5;
	margin-bottom: 20px;
}

.mainContainer .textClass{
	padding: 10px 14px;
	margin-bottom: 20px;
}
.mainContainer .el-row {
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.mainContainer .formSelect {
	width: 100%;
}
.mainContainer .radioClass{
	margin-right:16px;
}
</style>
